import { Navigate, useLocation } from 'react-router-dom'

import { getServiceInstanceIdFromPost, withServiceInstanceId } from '@/lib/service-instance'
import { isOrganizationServiceVariant } from '@/lib/service-variant-types'
import { useAuthStore } from '@/stores/auth-store'

type VariantRouteRule = {
  uniqueIds: string[]
  labels: string[]
  path: string
}

const VARIANT_HOME_ROUTES: VariantRouteRule[] = [
  { uniqueIds: ['700'], labels: ['retail'], path: '/services/pos' },
]

function normalizeToken(value?: string | number | null) {
  return String(value ?? '').trim().toLowerCase()
}

function resolveServiceVariantHomePath(
  variantUniqueId?: string | number | null,
  variantLabel?: string | null,
) {
  const uniqueId = normalizeToken(variantUniqueId)
  const label = normalizeToken(variantLabel)

  const rule = VARIANT_HOME_ROUTES.find((item) => (
    item.uniqueIds.includes(uniqueId) || item.labels.includes(label)
  ))

  return rule?.path || '/dashboard'
}

export default function ServiceVariantDashboard() {
  const location = useLocation()
  const currentPost = useAuthStore((state) => state.currentPost)
  const params = new URLSearchParams(location.search)
  const serviceInstanceId = params.get('service_instance_id') || getServiceInstanceIdFromPost(currentPost)
  const variantUniqueId = currentPost?.service_variant_unique_id ?? params.get('variant')
  const variantLabel = currentPost?.service_variant_name ?? currentPost?.service_variant_type ?? params.get('variant')

  if (isOrganizationServiceVariant(variantUniqueId, variantLabel)) {
    return <Navigate to={withServiceInstanceId('/dashboard', serviceInstanceId)} replace />
  }

  return <Navigate to={withServiceInstanceId(resolveServiceVariantHomePath(variantUniqueId, variantLabel), serviceInstanceId)} replace />
}
